import moment from "../../../node_modules/moment/moment";
import ReplacementCandidate from "./ReplacementCandidate";

export class Replacement {
    private _id: string;
    private _name: string;
    private _creationDate: moment.Moment;
    private _validityDate: moment.Moment | null;
    private _candidates : ReplacementCandidate[];
    private _haveJobPosition: boolean;

    constructor(data)  {
        this._id = data.id;
        this._name = data.name;
        this._creationDate = moment(data.creationDate);
        this._validityDate = data.validityDate ? moment(data.validityDate) : null;
        this._candidates  = data.candidates ? data.candidates.map(candidates => new ReplacementCandidate(candidates)) : [];
        this._haveJobPosition = data.haveJobPosition;
    }

    public get id() {
        return this._id;
    }
    
    public get name() {
        return this._name;
    }

    public get creationDate() {
        return this._creationDate;
    }

    public get validityDate() {
        return this._validityDate;
    }

    public get candidates () {
        return this._candidates ;
    }

    public get haveJobPosition() {
        return this._haveJobPosition;
    }
}